/* RESPONSIBLE TEAM: team-ai-agent */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import type IntlService from 'embercom/services/intl';
import type AppService from 'embercom/services/app-service';
import type RouterService from '@ember/routing/router-service';

class FinAiAgentEcommerceDeployChatRoute extends Route {
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare router: RouterService;

  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.ecommerce.deploy.chat',
  };

  beforeModel() {
    if (!this.appService.app.canUseFinEcommerceAgent) {
      this.router.transitionTo('apps.app.automation.fin-ai-agent.setup');
    }
  }

  get titleToken() {
    return this.intl.t('ai-agent.deploy.chat');
  }

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(FinAiAgentEcommerceDeployChatRoute);
